import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGuideAndRelationshipsMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  _set?: Types.InputMaybe<Types.Guides_Set_Input>;
  steps?: Types.InputMaybe<Array<Types.Guide_Steps_Insert_Input> | Types.Guide_Steps_Insert_Input>;
  deleteStepIds?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
  productGuides?: Types.InputMaybe<Array<Types.Product_Guides_Insert_Input> | Types.Product_Guides_Insert_Input>;
  deleteProductGuideIds?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type UpdateGuideAndRelationshipsMutation = { __typename?: 'mutation_root', update_guides_by_pk?: { __typename?: 'guides', id: any } | null, insert_guide_steps?: { __typename?: 'guide_steps_mutation_response', affected_rows: number } | null, delete_guide_steps?: { __typename?: 'guide_steps_mutation_response', affected_rows: number } | null, insert_product_guides?: { __typename?: 'product_guides_mutation_response', affected_rows: number } | null, delete_product_guides?: { __typename?: 'product_guides_mutation_response', affected_rows: number } | null };


export const UpdateGuideAndRelationshipsDocument = gql`
    mutation updateGuideAndRelationships($id: uuid!, $_set: guides_set_input = {}, $steps: [guide_steps_insert_input!] = [], $deleteStepIds: [uuid!] = [], $productGuides: [product_guides_insert_input!] = [], $deleteProductGuideIds: [uuid!] = []) {
  update_guides_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
  insert_guide_steps(
    objects: $steps
    on_conflict: {constraint: guide_steps_pkey, update_columns: [body, step_number, title, image_url, video_url]}
  ) {
    affected_rows
  }
  delete_guide_steps(where: {id: {_in: $deleteStepIds}}) {
    affected_rows
  }
  insert_product_guides(
    objects: $productGuides
    on_conflict: {constraint: product_guides_guide_id_product_id_key}
  ) {
    affected_rows
  }
  delete_product_guides(where: {id: {_in: $deleteProductGuideIds}}) {
    affected_rows
  }
}
    `;
export type UpdateGuideAndRelationshipsMutationFn = Apollo.MutationFunction<UpdateGuideAndRelationshipsMutation, UpdateGuideAndRelationshipsMutationVariables>;

/**
 * __useUpdateGuideAndRelationshipsMutation__
 *
 * To run a mutation, you first call `useUpdateGuideAndRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuideAndRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuideAndRelationshipsMutation, { data, loading, error }] = useUpdateGuideAndRelationshipsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *      steps: // value for 'steps'
 *      deleteStepIds: // value for 'deleteStepIds'
 *      productGuides: // value for 'productGuides'
 *      deleteProductGuideIds: // value for 'deleteProductGuideIds'
 *   },
 * });
 */
export function useUpdateGuideAndRelationshipsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuideAndRelationshipsMutation, UpdateGuideAndRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuideAndRelationshipsMutation, UpdateGuideAndRelationshipsMutationVariables>(UpdateGuideAndRelationshipsDocument, options);
      }
export type UpdateGuideAndRelationshipsMutationHookResult = ReturnType<typeof useUpdateGuideAndRelationshipsMutation>;
export type UpdateGuideAndRelationshipsMutationResult = Apollo.MutationResult<UpdateGuideAndRelationshipsMutation>;
export type UpdateGuideAndRelationshipsMutationOptions = Apollo.BaseMutationOptions<UpdateGuideAndRelationshipsMutation, UpdateGuideAndRelationshipsMutationVariables>;